<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Atuacao_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Áreas de Atuação</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="left">
        <p>Para todo o tipo de empresa, as melhores soluções do mercado veicular!</p>
      </div>

      <div class="list-topics">
        <div class="topic">Concessionárias</div>
        <div class="topic">Lojas Multimarcas</div>
        <div class="topic">Cliente</div>
        <div class="topic">ECV's</div>
        <div class="topic">BigData</div>
        <div class="topic">Frotistas</div>
        <div class="topic">Locadoras</div>
        <div class="topic">Financeiras</div>
        <div class="topic">Montadoras</div>
        <div class="topic">Seguradoras</div>
        <div class="topic">Marketplace</div>
        <div class="topic">Rastreamentos</div>
        <div class="topic">Gestão de Frota</div>
        <div class="topic">Assistências 24h</div>
        <div class="topic">Consultor Car Hunter</div>
        <div class="topic">Sindicatos Regionais</div>
        <div class="topic">Associações de Marca</div>
        <div class="topic">Corretoras de Seguros</div>
        <div class="topic">Empresas de Tecnologia</div>
        <div class="topic">Integradores de Anúncios</div>
        <div class="topic">Parcerias (Representantes)</div>
        <div class="topic">Empresas de Venda de Pneus</div>
        <div class="topic">Associações de Proteção Veicular</div>
        <div class="topic">Empresas de vistorias automotivas</div>
        <div class="topic">Plataforma de Precificação de Veículos</div>
        <div class="topic">Bancos, Consórcios, Escritórios de Cobrança</div>
        <div class="topic">Leilões/Empresas de Remarketing Automotivo</div>
        <div class="topic">Plataformas/Site de Venda e Anúncios de Veículos</div>
      </div>
    </div>
  </section>


  <app-contact-box></app-contact-box>
</main>
